<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>caricamento</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important" variant="warning"></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-row style="height:40vh;margin:0" class="welcome-picture">
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8" style="height:100%">
          <div class="language">
            <template>
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div>          
          <div class="welcome-overlay">
            <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>LOVER</h1>
            <p class="main-subtitle">creato da amanti del vino – per amanti del vino</p>
          </div> 
        </b-col>
      </b-row> 
      <b-row>
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8">
          <p class="w-title">Siamo un gruppo di appassionati di vino.</p>
          <p class="w-text">La nostra missione è migliorare l’esperienza digitale legata al vino in modo aperto e non commerciale. Per questo abbiamo creato <b>WyneLover</b>.</p>
          <p class="w-text">In una prima fase stiamo sviluppando una trilogia di applicazioni online interconnesse: WyneMaker, WyneCellar e WyneTaster.</p>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynemaker.com"><b>www.wynemaker.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Per i produttori di vino che vogliono condividere informazioni dettagliate sulla propria cantina e sui propri vini.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynecellar.com"><b>www.wynecellar.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Per gli appassionati di vino che desiderano gestire e organizzare la propria cantina personale.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynetaster.com"><b>www.wynetaster.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Per organizzare o partecipare a degustazioni di vino e gestire le proprie note di degustazione.</p>
            </b-col>
          </b-row>

          <p class="w-text">Una volta che il database WyneDatabase sarà sufficientemente popolato dai produttori che usano l'app WyneMaker, intendiamo condividerlo con il mondo tramite un'API aperta — a beneficio di appassionati, professionisti e sviluppatori.</p>
          
          <hr>

          <p class="w-title">Come puoi aiutarci?</p>
          <p class="w-subtitle">Supporto attivo.</p>
          <p class="w-text">Cerchiamo volontari appassionati con competenze diverse per completare e promuovere il progetto:</p>
          <p class="w-text" style="margin:15px">&#9642; marketing e promozione</p>
          <p class="w-text" style="margin:15px">&#9642; conoscenze sul vino (regionali o generali)</p>
          <p class="w-text" style="margin:15px">&#9642; web design, UI/UX</p>
          <p class="w-text" style="margin:15px">&#9642; competenze linguistiche e comunicative in diversi paesi</p>
          <p class="w-text" style="margin:15px">&#9642; contatti con produttori di vino, associazioni, riviste specializzate</p>
          <p class="w-text">Se l’idea di contribuire al futuro digitale del vino ti entusiasma e vuoi unirti al nostro team di volontari, saremo felici di sentirti.</p>
          <p class="w-text">Ti interessa diventare un <b>WyneBassador</b>?</p>
          <p class="w-text">Scrivici a <b>admin@wynelover.com</b> e raccontaci quali competenze puoi offrire al progetto.</p>
          
          <p class="w-subtitle">Supporto passivo.</p>
          <p class="w-text">Ci impegniamo a mantenere questo progetto aperto e non commerciale. Questo significa che contiamo interamente sulle donazioni. Se ti piace quello che stiamo costruendo e vuoi supportarci, considera di cliccare sul pulsante "dona" qui sotto.</p>

          <hr>

          <b-row>
            <b-col class="text-left">
              <b-button v-on:click="onBack()" class="w-button-pink">indietro</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button v-on:click="onDonate()" class="w-button-green">dona</b-button>
            </b-col>
          </b-row>
          <br>    
        </b-col>
      </b-row>
      <br>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WineryWelcome',
     computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },             
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false, 
        isLoading: true,
      }
    }, 
    mounted() {
      this.isLoading = false
    },
    methods: {
      onBack() {
        this.$router.push({path:'/Winery/'+this.previousPage, query: {winery_id:this.$route.query.winery_id }});
        this.$store.commit('setPage',this.previousPage)
      },
      onDonate() {
        window.open('https://www.paypal.com/donate/?hosted_button_id=968LLYKG8YBP6');
      },
      
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100vw;
    height:auto;
    
    background-image: url("../../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  width:100%;
  max-width: none !important; 
  position: relative;
  top: 10vh;
}

.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
  z-index: 10;  
}
</style> 